module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('data-table', {
    attrs: {
      "table-ref": "insurance-table",
      "title": _vm.title,
      "icon": "fa fa-shield-alt",
      "url": '/insurance' + (this.siteId ? '/site/' + Number(this.siteId) : '') + (this.telcoId ? '/org/' + Number(this.telcoId) : ''),
      "fields": _vm.insuranceFields,
      "sort-field": "policyType",
      "params": _vm.site,
      "add-action": _vm.isManager('finance|property|admin') ? _vm.addAction : null,
      "add-props": _vm.addProps,
      "detail-component": "insurance-detail-row"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-702ee376"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tables/InsuranceTable.vue
// module id = 1633
// module chunks = 0